import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, UntypedFormGroup, UntypedFormBuilder, UntypedFormArray } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';

@Component({
    selector: 'app-witness-details',
    templateUrl: './witness-details.component.html',
    styleUrls: ['./witness-details.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatCheckboxModule,
        MatButtonModule,
        MatTableModule,
        MatExpansionModule,
        MatIconModule,
        MatRadioModule
    ]
})
export class WitnessDetailsComponent implements OnInit {
  form: UntypedFormGroup;
  displayedColumns: string[] = ['name', 'address', 'contactNumber', 'type', 'description'];
  dataSource;

  constructor(private fb: UntypedFormBuilder, private readonly cdr: ChangeDetectorRef) {}
  ngOnInit() {
    this.form = this.fb.group({
      witnessDetails: this.fb.array([]),
    });
    this.addRow(); // Add initial row

    this.dataSource = [...this.witnessDetails.controls];
  }

  get witnessDetails() {
    return this.form.get('witnessDetails') as UntypedFormArray;
  }

  addRow() {
    const personForm = this.fb.group({
      witnessName: [''],
      witnessAddress: [''],
      witnessContactNumber: [''],
      witnessType: [''],
      witnessDescription: [''],
    });
    this.witnessDetails.push(personForm);
    this.dataSource = [...this.witnessDetails.controls];
    this.cdr.detectChanges();
  }

  removeRow(index: number) {
    this.witnessDetails.removeAt(index);
    this.updateDataSource();
  }

  private updateDataSource() {
    this.dataSource = [...this.witnessDetails.controls];
    this.cdr.detectChanges();
  }
}
